<template>
    <div class="account-container">
        <div>
            <div class="account-tray">
                <div class="account-header">
                    <div>
                        <img v-if="user.pictureUrl" class="circle" v-bind:src="user.pictureUrl">
                        <img v-else class="circle" src="../assets/icons/anonymous.svg">
                        <p class="user-name">{{user.firstName}} {{user.lastName}}</p>
                        <p class="title">{{$t('str.ConnectYourSocialAccounts')}}</p>
                        <a class="close-btn" v-on:click="close">
                            <i class="fa fa-times"></i>
                        </a>
                    </div>
                </div>
                <div class="account-body">
                    <div>
                        <ul class="social-accounts">
                            <li v-for="(title, socialMediaKey) in socialMedias" v-bind:key="socialMediaKey" class="account">
                                <h3 class="account-title">{{title}}</h3>
                                <img v-if="getUserSocialMediaProfile(socialMediaKey)" class="profile-picture circle" v-bind:src="getProfilePicture(socialMediaKey)">
                                <i v-else class="social-profile-icon circle" v-bind:class="socialMediaIcon(socialMediaKey)"></i> 
                                <p>
                                    <a v-if="isConnected(socialMediaKey)" v-bind:href="getProfileUrl(socialMediaKey)" target="_blank">{{user.firstName}} {{user.lastName}}</a>
                                </p>
                                <a v-if="isConnected(socialMediaKey)" class="secondary-content" v-on:click="unlinkAccount(socialMediaKey)">
                                    <img class="account-btn circle" src="../assets/icons/x.svg">
                                </a>
                                <a v-else class="secondary-content" v-on:click="linkAccount(socialMediaKey)">
                                    <img class="account-btn circle" src="../assets/icons/plus.svg">
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="account-footer">
                    <div>
                        <a v-on:click="close">{{$t('str.Close')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// TODO: websocket or force rerender to update UI when new account linked
import {EventBus} from '../router/index';

export default {
    props: {
        user: {},
        service: Object
    },

    data() {
        return {
            socialMedias: {
                linkedin: 'LinkedIn',
                twitter: 'Twitter',
                facebook: 'Facebook'
            }
        };
    },

    methods: {
        isConnected(socialMedia) {
            return !!this.getUserSocialMediaProfile(socialMedia);
        },

        getProfileUrl(socialMedia) {
            var userProfile = this.getUserSocialMediaProfile(socialMedia);
            if (userProfile !== undefined && userProfile[0].network === socialMedia) {
                return userProfile[0].profileUrl;
            }
        },

        getProfilePicture(socialMedia) {
            var userProfile = this.getUserSocialMediaProfile(socialMedia);
            return userProfile && userProfile[0].network === socialMedia && userProfile[0].pictureUrl ? userProfile[0].pictureUrl : '/static/img/anonymous.svg';       
        },

        socialMediaIcon(socialMedia) {
            return 'fa fa-' + socialMedia;            
        },

        unlinkAccount(socialMedia) {
            var userProfile = this.getUserSocialMediaProfile(socialMedia);
            var socialIndex = userProfile[1];

            if (userProfile[0].network === socialMedia) {
                this.user.social.splice(socialIndex, 1);
                EventBus.$emit('unlinkAccount', socialMedia);
            }
        },

        getUserSocialMediaProfile(socialMedia) {
            var socialMediasCount = this.user.social.length;

            for (var i = 0; i < socialMediasCount; i++) {
                if (this.user.social[i].network === socialMedia) {
                    return [this.user.social[i], i];
                }
            }
        },

        linkAccount(socialMedia) {
            // links only for testing. Server will handle redirects
            var authBaseUrl = this.service.getLoginUrl(socialMedia);

            if (!authBaseUrl) {
                return;
            }

            authBaseUrl += `&u=${this.user.id}`;

            var socialWindow = window.open(authBaseUrl);

            if (socialWindow === null) {
                return;
            }

            var userId = this.user.id;
            var profileFound = this.getUserSocialMediaProfile(socialMedia);

            function retry(nbTries) { 
                if (++nbTries > 20) {
                    return;
                }

                var successful = profileFound;
                
                setTimeout(() => { 
                    EventBus.$emit('getUser', userId);

                    if (!successful) {
                        retry(nbTries);
                    } 
                }, 2000);
            }

            retry(0);           
        },

        refreshUI(socialMedia) {
            var userProfile = this.getUserSocialMediaProfile(socialMedia);
            while (!userProfile) {
                setTimeout(this.$emit('getUser', this.user.id), 3000);
                userProfile = this.getUserSocialMediaProfile(socialMedia);
            }  
        },

        close() {
            this.$emit('closeModal');
        }
    }
};

</script>

<style lang="scss">

.account-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5001;

    & > div {
        position: absolute;
        top: 65px;
        bottom: 65px;
        left: 0;
        right: 0;
    }
}

.circle {
    border-radius: 50%;
}

.account-tray {
    box-sizing: border-box;
    display: table;
    width: 95%;
    max-width: 500px;
    background-color: #333;
    color: #fff;
    margin: 65px auto 65px auto;
    overflow: hidden;
    font-size: 1em;
    line-height: 1.5;
    font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: normal;
    padding: 10px;

    & > div {
        display: table-row;
        height: 1px;
    }

    .close-btn {
        position: absolute;
        top: 0;
        right: 10px;
        cursor: pointer;
    }

    .account-header {
        text-align: center;
        padding: 0;

        & > div {
            position: relative;
            padding: 0 0 20px 0;
        }

        img {
            height: 80px;
            border: 5px solid rgba(241, 242, 242, 0.38);
            margin: 5px 0px 0px 5px;
            width: 80px;
        }

        .user-name {
            font-weight: 500;
            margin: 0;
            font-size: 1em;
            color: #d4451d;
        }

        .title {
            color: #cbcbcb;
            font-size: .9em;
            margin: 25px 0 0 0;
            font-weight: 400;
            line-height: 110%;
        }
    }

    .account-body {
        color: #f1f2f2;
        font-size: 16px;
        margin-top: 5px;
        overflow-y: auto;
        height: 100%;

        .social-accounts {
            list-style-type: none;
            margin: 0;

            .account {
                height: 45px;
                position: relative;
                line-height: 1.5rem;
                padding: 5px 0px;
                margin: 5px;
                list-style-type: none;
                border: 1px groove rgba(255, 255, 255, 0.07);

                .i {
                    height: 50px;
                    width: 50px;
                    top: 8px;
                    line-height: 50px;
                    font-size: 1em;
                    color: #fff;
                    background-color: #999;
                    text-align: center;

                    position: absolute;
                    overflow: hidden;
                    left: 15px;
                    display: inline-block;
                    vertical-align: middle;
                }

                .account-title {
                    font-weight: 6800;
                    font-size: 15px;
                    padding-left: 60px;
                    margin: 0;
                }

                .profile-picture {
                    position: absolute;
                    top: 2px;
                    height: 50px;
                    width: 50px;
                    overflow: hidden;
                }

                .social-profile-icon {
                    position: absolute;
                    top: 2px;
                    background-color: rgba(241, 242, 242, 0.38);
                    height: 50px;
                    width: 50px;
                    line-height: 50px;
                    text-align: center;
                }

                p {
                    margin: 0;
                    word-wrap: break-word;
                    font-size: .8em;
                    max-width: 90%;
                    padding-left: 70px;

                    a {
                        text-decoration: none;
                        color: #d4451d;
                        background-color: transparent;
                        cursor: pointer;
                    }
                }

                .secondary-content {
                    font-size: 20px;
                    position: absolute;
                    top: 10px;
                    right: 0;

                    .account-btn {
                        width: 30px;
                        height: 30px;
                        line-height: 100%;
                        cursor: pointer;
                        display: inline-block;
                    }
                }
            }
        }
    }

    .account-footer > div {
        padding: 15px 20px 10px 20px;
        color: #d4451d;
        text-transform: uppercase;
        float: right;

        a {
            cursor: pointer;
        }
    }
}

</style>


// WEBPACK FOOTER //
// ProfileManagement.vue?1bc59569